export const TESTPLAN_TESTRUN_STATUS = {
    PREPARING: 'Preparing',
    RUNNING: 'Running',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};

export const HAND_TEST_RESULT = {
    PASSED: 'Passed',
    FAILED: 'Failed',
    BLOCKED: 'Blocked',
};

export const AUTO_TEST_RESULT = {
    PASSED: 'Passed',
    FAILED_NA: 'Failed N/A',
    DEPLOY_FAILED: 'Deploy failed',
    FAILED: 'Failed',
    BROKEN: 'Broken',
    NOT_FOUND: 'Not found',
    BLOCKED: 'Blocked',
};

export const HAND_TEST_RUN_STATUS = {
    PREPARING: 'Preparing',
    READY_TO_START: 'Ready to start',
    IN_PROGRESS: 'In progress',
    PAUSED: 'Paused',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};

export const AUTO_TEST_RUN_STATUS = {
    PREPARING: 'Preparing',
    RUNNING: 'Running',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
};

export const AUTO_TEST_RUN_STATUS_COLOR = {
    COMPLETED: 'var(--info-main)',
};

export const ALLURE_REPORT_BACKGROUND_COLOR = {
    PASSED: 'var(--success-selected)',
    FAILED_NA: 'var(--warning-dark-selected)',
    FAILED: 'var(--error-selected)',
    DEPLOY_FAILED: 'var(--error-selected)',
    BROKEN: 'var(--charts-warning-selected)',
    NOT_FOUND: '',
    BLOCKED: 'var(--charts-deep-purple-selected)',
};

export const TEST_RESULT_CONFIG = {
    passed: {
        color: 'success',
    },
    failed: {
        color: 'error',
    },
    failed_na: {
        color: 'error',
        variant: 'outlined',
    },
    deploy_failed: {
        sx: {
            backgroundColor: 'var(--semantic-charts-error-default)',
            color: 'primary.contrastText',
        },
    },
    broken: {
        sx: {
            backgroundColor: 'var(--semantic-charts-warning)',
        },
    },
    blocked: {
        sx: {
            backgroundColor: 'var(--semantic-charts-deep-purple)',
            color: 'primary.contrastText',
        },
    },
    not_found: {},
};
